import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { getPermissionFlags } from "utils/permissions";

export const useLevelAdmin = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const user = useSelector((state) => state.user);

  const { showOrg } = getPermissionFlags(user);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentLevel, setCurrentLevel] = useState(null); // Store the year being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentLevel(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((year) => {
    setEditMode(true);
    setCurrentLevel(year);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentLevel,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showOrg,
  };
};
